<template>
    <div v-if="article.article_languages[0] != null" class="Analysis-left" style="margin-bottom: 14px">
        <div>
            <figure>
                <div class="img-scale-in">
                    <a style="height: 100%" :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""/></a>
                </div>
                <figcaption>
                    <div class="Analysis-left-top">
                        <h2><a
                            :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{
                                article.category.category_languages[0].pivot.name
                            }}</a>
                        </h2>
                        <span>{{ formattedCreatedAt }}</span>
                    </div>

                    <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h3>
                    <p v-if="article.second_author == null">{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b></p>
                    <p v-else>{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b> & <b>{{ article.second_author.author_languages[0].pivot.name }}</b></p>
                </figcaption>

            </figure>

        </div>
    </div>
</template>

<script>
export default {
    name: 'SecondSliderArticle',
    props: {
        article: {
            type: Object,
            default: []
        },
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.article.published_at ?? this.article.created_at).replace(' ', 'T'));
            const options = {month: 'short', day: 'numeric', year: 'numeric'};
            return date.toLocaleDateString(this.$store.state.language.code === 'ar' ? 'ar-LB' : 'en-US', options).toUpperCase();
        }
    }
}
</script>

<style>

</style>

<style scoped>
.Analysis-list-left {
    max-width: 20%;
    display: inline-block;
}

.Analysis-list-right {
    display: inline-block;
    padding-left: 20px;
}

@media (max-width: 570px) {
    .Analysis-list-left {
        width: 100%;
        max-width: 100%;
    }

    .Analysis-list-right {
        width: 100%;
    }
}
</style>
